import Vue from 'vue'
import IconSVG from '~/components/common/IconSVG'
import Button from '~/components/common/Button'
import Avatar from '~/components/common/Avatar'

const components = { IconSVG, Button, Avatar }

Object.entries(components).forEach(([name, component]) => {
  Vue.component(name, component)
})
